import React, {FunctionComponent} from "react";
import Typography from "@mui/material/Typography";
import {Stack, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";

export const SignatureEditor: FunctionComponent<SignatureEditorProp> = props => {
    const {t} = useTranslation();

    return <Stack spacing={1}>
        <Typography variant="h6">
            {t("Signatures")}
        </Typography>

        <TextField label={t("Signatures")}
                   value={props.values.join(";")}
                   fullWidth
                   onChange={(ev) => {
                       props.setValue(ev.target.value.split(";"));
                   }}
                   helperText={t('* use semicolon (";") as separator')}/>
    </Stack>
}

export interface SignatureEditorProp {
    values: string[];
    setValue: (newValues: string[]) => void;
}